import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
    icon: string;
    title: string;
    body: string;
    btns_lst: any
}

@Component({
    selector: 'custom-dialog',
    templateUrl: './custom_dailog.html',
})
export class CustomDialougeBox {
    // data;
    constructor(
        public dialogRef: MatDialogRef<CustomDialougeBox>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {
        if (data && data['btns_lst'] && data['btns_lst'].length) {
            data['btns_lst'].filter((k) => {
                console.log(k, 'buttonnnnnnnnnnnnnnnnnn');
                
                if (k['title']) {
                    k['color'] = 'blue';
                    let text = '' + k['title']
                    let ok_result = text.match(/ok/gi);
                    if (ok_result) {
                        k['color'] = 'warn';
                    }

                    let cncl_result = text.match(/cancel/gi);
                    if (cncl_result) {
                        k['color'] = '#00f';
                        k['backgroundColor'] = 'transparent';  
                        k['border'] = '2px solid green'; 
                    }

                    let del_result = text.match(/delete/gi);
                    if (del_result) {
                        k['color'] = 'warn';
                    }

                    

                }
            })
        }
    }

    onBtnClick(res): void {
        this.dialogRef.close(res);
    }

}